<template>
  <div class="mun-wrap">
    <div class="textarea-wrap">
      <el-input type="textarea" readonly v-model="upLoadData.content" autocomplete="off"
        size="small" ></el-input>
      <div class="upload-wrap">
        <!-- 图片列表 v-show="photoList.length != 0"-->
        <div class="upload-photo-wrap" >
          <div class="photo-item" v-for="(item,index) in photoList" :key="index">
            <div class="photo-wrap" >
              <el-image 
                @click="previewImage(item.resourceUrl)"
                class="photo"
                :src="item.resourceUrl"
                fit="contain"
              >
                  <!-- src="http://36.137.14.25:9090/wecom/wpHiy3CAAAJEpISih4OQ4Pw95UHKo8sg/2022/10/21/966b55be-c02b-42e7-99aa-37837b5a01d0.jpg" -->
              </el-image>
            </div>
            <span class="photo-name">{{item.resourceName}}</span>
          </div>
        </div>
        <!-- 视频  -->
        <div class="upload-video-wrap" v-show="videoList.length != 0">
          <!-- <video width="100%" v-show="false" controls="controls" crossOrigin="Anonymous" id="myVideo">
          </video> -->
          <div class="item-wrap" v-if="videoList.length != 0">
            <div class="item-left" @click="videoShow = true">
              <el-image 
                v-if="imgsrc"
                class="photo"
                :src="imgsrc" 
              >
              </el-image>
              <span class="start-wrap">
                <el-image 
                  class="start-icon"
                  :src="require('@/assets/img/start.png')" 
                >
                </el-image>
              </span>
            </div>
            <div class="item-right">
              <div class="video-name">{{ videoList[0].name }}</div>
            </div>
          </div>
        </div>
      <!-- 小程序 -->
      <div class="applet-wrap" v-if="upLoadData.appletVo">
        <div class="applet-item" >
          <div class="item-left">
            <img class="img" src="@/assets/img/applet.png" alt="" />
          </div>
          <div class="item-right">
            <div class="title">{{ upLoadData.appletVo.name }}</div>
            <div class="content">
              {{ upLoadData.appletVo.url }}
            </div>
          </div>
        </div>
      </div>
        <!-- 链接 -->
        <div class="link-wrap" v-if="linkList.length != 0">
          <div class="link-item">
            <div class="item-left">
              <div class="title">{{linkList[0].title}}</div>
              <div class="content" v-if="linkList[0].linkType == 'goods'">
                {{ linkList[0].content&& '商城价:￥'+ linkList[0].price }}
              </div>
              <div class="content" v-else-if="linkList[0].linkType == 'coupon'">
                {{ linkList[0].content&& '满'+ linkList[0].couEnableprice + '减' + linkList[0].price }}
              </div>
            </div>
            <div class="item-right" >

              <el-image 
                v-if="linkList[0].pictureUrl && linkList[0].linkType != 'coupon'"
                @click="previewImage(linkList[0].pictureUrl)"
                class="photo"
                :src="linkList[0].pictureUrl" 
              >
              </el-image>
              <el-image 
                v-else
                :src="require('@/assets/img/ticket.jpg')"
                @click="previewImage(require('@/assets/img/ticket.jpg'))"
                class="photo"
              >
              </el-image>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 视频预览 -->
    <el-dialog class="video-dialog" :visible.sync="videoShow"  width="400px" style="margin-top:0vh;" close-on-click-modal append-to-body>
      <video width="100%" height="auto" v-if="videoList.length != 0" autoplay="autoplay" controls="controls">
        <source :src="videoList[0].fileFullUrl" type="video/mp4" />
      </video>
    </el-dialog>
    <el-image 
      class="my-preview-image"
      :src="previewUrl" 
      ref="myImg"
      :preview-src-list="previewSrcList">
    </el-image>
    <!-- 用画布截取视频的第一帧作为封面 -->
    <canvas id="mycanvas" style="display: none"></canvas>
  </div>
</template>
<script>
export default {
  name: "myUploadDetail",
  components: {
  },
  props: {
    // myType 为1时 新增好友sop，为2时生日提醒sop，为3时新增朋友圈sop,4为活吗，5为群发
    myType: {
      type: Number,
      default: 1
    },
    upLoadData: {
      type: Object,
      default: () => ({
        content: '',
        resourceVos: [],
        sopLink: [],
        appletVo:null
      })
    }
  },
  data() {
    return {
      videoShow: false,
      previewUrl: '',
      previewSrcList: [],
      content: '',
      type: 0,                  // 类型 0 图片，1视频，2链接  
      photoList: [],            // 上传的图片数组
      videoList: [],
      imgsrc: '',               // 视频封面
      linkList: [],             // 链接列表
    };
  },
  created() {
  },
  watch: {
    upLoadData: {
      handler(newVal,oldVal) {
        this.linkList = []
        this.photoList = []
        this.videoList = []
        console.log('upLoadDataval11111111',JSON.parse(JSON.stringify(newVal)))
        console.log('newVal.sopLink',newVal.sopLink,newVal.sopLink && newVal.sopLink != null,newVal.sopLink != null)
        if(newVal.sopLink && newVal.sopLink != null) {
          console.log('11111111')
          this.linkList.push(newVal.sopLink)
        }else {
          if(newVal.resourceVos.length !=0 ) {
            if(newVal.resourceVos[0].resourceType == 'image') {
              this.photoList = newVal.resourceVos
            }else {
              this.findvideocover(newVal.resourceVos[0].resourceUrl,newVal.resourceVos[0].resourceName)
            }
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
  },
  methods: {
    //截取视频第一帧作为播放前默认图片
    findvideocover(url, name) {
      let that = this
      console.log('22222222222222222')
      that.$nextTick(() => {
        console.log('333333333')
        // const video = document.getElementById("myVideo")
        // <video width="100%" v-show="false" controls="controls" crossOrigin="Anonymous" id="myVideo">
        //   </video>
        const video = document.createElement("video")
        video.crossOrigin="Anonymous"
        const source = document.createElement("source")
        source.src = url
        source.type = "video/mp4"
        console.log('4444444444',video)
        video.appendChild(source)
        video.currentTime = 1 // 第一帧
        that.videoList = []
        let obj = {
          fileFullUrl: url,
          imgsrc: '',
          name: name
        }
        that.videoList.push(obj)
        video.addEventListener("loadeddata",function() {
          console.log('5555555555')
          var canvas =  document.createElement("canvas")
          canvas.width = 142
          canvas.height = 142
          canvas.getContext("2d").drawImage(video,0,0,canvas.width,canvas.height)
          that.imgsrc = canvas.toDataURL ("image/png") // 截取后的视频封面
          that.videoList[0].imgsrc = that.imgsrc
          console.log('that.videoList',that.videoList)
        })
      })
    },
    previewImage(url) { 
      this.previewSrcList = [];
      this.previewUrl = url;
      this.previewSrcList.push(url);
      this.$refs.myImg.showViewer = true;
    }
  }
};
</script>
<style lang="scss">
.my-pop {
  .emoji {
    display: inline-block;
    padding: 3px;
    border: 1px solid transparent;
    cursor: pointer;
    background: #fff;
    font-size: 16px;

    &:hover {
      background-color: #ddded8;
      border: 1px solid #b3c1fd;
      border-radius: 4px;
    }
  }
}
.video-dialog {
  .el-dialog {
    box-shadow: unset;
    width: 100%;
    background-color: unset;
    margin-top: 7vh !important;
    .el-dialog__headerbtn {
      display: none;
    }
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      padding: 0;
      display: flex;
      justify-content: center;
      background-color: transparent;
    }
  }
}
</style>
<style lang="scss" scoped>
.mun-wrap {
  line-height: initial;
  .textarea-wrap {
    border: 1px solid #E6E9EB;
    border-radius: 4px;
    padding: 0;
    margin-bottom: 15px;
    .top-wrap {
      padding: 7px 10px 5px 10px;
      border-bottom: 1px solid #EEEFF3;
      .margin18 {
        margin-right: 18px;
      }
      .set-color {
        color: #2684FF;
        cursor: pointer;
      }
    }
    /deep/ .el-textarea__inner {
      min-height: 200px !important;
      padding: 10px;
      border: none;
      resize: none !important;
    }
  }
  .upload-wrap {
    border-top: 1px solid #EEEFF3;
    padding: 11px 10px 0px 10px;
    .upload-photo-wrap {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      .photo-item {
        display: flex;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-right: 28px;
        margin-bottom: 14px;
        .photo-wrap {
          position: relative;
          height: 40px;
          width: 40px;
          cursor: pointer;
          .photo {
            width: 100%;
            height: 100%;
          }
        }
        .photo-name {
          font-size: 14px;
          color: #666666;
          margin-left: 9px;
          max-width: 9em;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        
      }
    }
    .upload-video-wrap {
      display: flex;
      margin-bottom: 13px;
      .item-wrap {
        display: flex;
        align-items: center;
        position: relative;
        .item-left {
          width: 71px;
          height: 71px;
          position: relative;
          .photo {
            width: 100%;
            height: 100%;
          }
          .start-wrap {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            .start-icon {
              width: 16px;
              height: 16px;
            }
          }
        }
        .item-right {
          padding-left: 13px;
          width: 190px;
          background: #F9F9F9;
          height: 100%;
          display: flex;
          align-items: center;
          .video-name {
            font-size: 14px;
            color: #666666;
            overflow:hidden; //超出的文本隐藏
            text-overflow:ellipsis; //溢出用省略号显示
            white-space:nowrap; //溢出不换行
          }
        }
        .close-wrap {
          position: absolute;
          top: -6px;
          right: -6px;
          border-radius: 50%;
          width: 13px;
          height: 13px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          cursor: pointer;
          background-color: #FF5E6A;
          .close-icon {
            color: white;
          }
        }
      }
      
    }
    .link-wrap {
      display: flex;
      margin-bottom: 13px;
      .link-item {
        background: #F9F9F9;
        padding: 9px 9px 9px 11px;
        display: flex;
        align-items: center;
        position: relative;
        .item-left {
          width: 163px;
          margin-right: 26px;
          .title {
            font-weight: 600;
            font-size: 14px;
            letter-spacing: -0.01px;
            color: #666666;
            margin-bottom: 4px;
          }
          .content {
            font-weight: 400;
            font-size: 10px;
            line-height: 16px;
            letter-spacing: -0.01px;
            color: #666666;
            overflow: hidden;
            text-overflow: ellipsis;
            display:-webkit-box; //作为弹性伸缩盒子模型显示。
            -webkit-box-orient:vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
            -webkit-line-clamp:2; //显示的行
          }
        }
        .item-right {
          width: 55px;
          height: 53px;
          cursor: pointer;
          .photo {
            height: 100%;
            width: 100%;
          }
        }
        .close-wrap {
          position: absolute;
          top: -6px;
          right: -6px;
          border-radius: 50%;
          width: 13px;
          height: 13px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          cursor: pointer;
          background-color: #FF5E6A;
          .close-icon {
            color: white;
          }
        }
      }
    }
  }
  .my-preview-image {
    width: 100px;
    height: 100px;
    display: none;
    /deep/ .el-image__inner{
        visibility: hidden !important;
    }
  }
  
}
 .applet-wrap {
      display: flex;
      margin-bottom: 13px;

      .applet-item {
        width: 250px;
        background: #f9f9f9;
        padding: 9px 9px 9px 11px;
        display: flex;
        align-items: center;
        position: relative;
        border-radius: 4px;
        gap: 10px;

        .item-left {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;

          .img {
            height: 100%;
            width: 100%;
          }
        }

        .item-right {
          width: 200px;

          .title {
            font-weight: 600;
            font-size: 14px;
            letter-spacing: -0.01px;
            color: #666666;
            margin-bottom: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
          }

          .content {
            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
            color: #666666;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box; //作为弹性伸缩盒子模型显示。
            -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
            -webkit-line-clamp: 1; //显示的行
          }

          .photo {
            height: 100%;
            width: 100%;
          }
        }

        .close-wrap {
          position: absolute;
          top: -6px;
          right: -6px;
          border-radius: 50%;
          width: 13px;
          height: 13px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          cursor: pointer;
          background-color: #ff5e6a;

          .close-icon {
            color: white;
          }
        }
      }
    }
</style>